/**
 * @generated SignedSource<<9ff1628886a122f0a63ae3af27d26711>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPBanksListQuery$variables = {
  itpCode?: string | null | undefined;
  search?: string | null | undefined;
};
export type PaymentActiveITPBanksListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPBanksList_query">;
};
export type PaymentActiveITPBanksListQuery = {
  response: PaymentActiveITPBanksListQuery$data;
  variables: PaymentActiveITPBanksListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itpCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itpCode",
    "variableName": "itpCode"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentActiveITPBanksListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "PaymentActiveITPBanksList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentActiveITPBanksListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ITPBankConnection",
        "kind": "LinkedField",
        "name": "itpBanks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ITPBankEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ITPBank",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providerParticipantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0989824b76335c9867555d47c42cb5f1",
    "id": null,
    "metadata": {},
    "name": "PaymentActiveITPBanksListQuery",
    "operationKind": "query",
    "text": "query PaymentActiveITPBanksListQuery(\n  $itpCode: String\n  $search: String\n) {\n  ...PaymentActiveITPBanksList_query_2S1FEk\n}\n\nfragment PaymentActiveITPBanksList_query_2S1FEk on Query {\n  itpBanks(itpCode: $itpCode, search: $search) {\n    edges {\n      node {\n        providerId\n        providerParticipantId\n        name\n        logo\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "66bd92491fef3accfea966882df15d1f";

export default node;
